export const organization = {
  add: {
    label: "Ajouter une organisation",
  },
  delete: {
    label: "Supprimer l'organisation",
  },
  form: {
    name: { label: "Nom" },
    description: { label: "Description" },
    address: { label: "Adresse" },
    image: { label: "Logo" },
    defaultTemplate: { label: "Gabarit d'intervention par défaut" },
  },
};
